export default class RegistrationForm {
    constructor($el) {
        this.$el = $el;

        const REGISTRATION_TYPE_COMPANY = 0;
        const REGISTRATION_TYPE_PRIVATE = 1;

        const companyFieldIds = [
            'company', 'companyPhone', 'vat', 'companyOverseerName', 'companyOverseerSurname', 'companyOverseerEmail',
            'invoiceFor', 'orderNumber', 'billingEmail', 'billingAddress', 'otherBillingAddress'
        ];

        this.companyFields = {};
        companyFieldIds.forEach(id => {
            const $input = $el.querySelector(`[data-role="${id}"]`);
            this.companyFields[id] = $input.closest('.form__group');

            if (id === 'otherBillingAddress') {
                this.companyFields[id].addEventListener('change', (e) => {
                    if (e.target.checked) {
                        this.companyFields['billingAddress'].classList.remove('no-display');
                    } else {
                        this.companyFields['billingAddress'].classList.add('no-display');
                    }
                });
            }
        });

        this.toggleCompanyFields();

        $el.querySelectorAll('[data-role="registrationType"]').forEach($radio => {
            $radio.addEventListener('change', (e) => {
                this.toggleCompanyFields(e.target.value == REGISTRATION_TYPE_COMPANY);
            });

            if ($radio.checked) {
                this.toggleCompanyFields($radio.value == REGISTRATION_TYPE_COMPANY);
            }
        });
    }

    toggleCompanyFields(show = false) {
        Object.keys(this.companyFields).forEach(id => {
            if (id === 'billingAddress') {
                if ( ! this.$el.querySelector('[data-role="otherBillingAddress"]').checked) {
                    this.companyFields[id].classList.add('no-display');
                    return;
                }
            }

           if (show) {
               this.companyFields[id].classList.remove('no-display');
               return;
           }

            this.companyFields[id].classList.add('no-display');
        });
    }
}